import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {LoginService} from '../../services/login.service';
import {EditingService} from '../../services/editing.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import {ApiCallsService} from '../../services/api-calls.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [AsyncPipe]
})
export class AdminComponent {
  afAuth = inject(AngularFireAuth);
  private loginService = inject(LoginService);
  private editingService = inject(EditingService);
  private apiCalls = inject(ApiCallsService);
  private destroyRef = inject(DestroyRef);

  settings;
  constructor() {
    this.apiCalls.getSettings().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        data => {
            console.log('settings:' , data);
          this.settings = data;
        }
    );
  }

  login() {
    firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }
  logout() {
    firebase.auth().signOut();
  }

  publish() {
    this.apiCalls.setPublished().subscribe(
        response => {
          console.log(response);
        },
        errors => {
          console.log(errors);
        }
    );
  }
  unPublish() {
    this.apiCalls.setUnPublished().subscribe(
        response => {
          console.log(response);
        },
        errors => {
          console.log(errors);
        }
    );
  }
}
